import { ClientFilters, Filters, JobFilters } from "../@types/filters";

export const defaultJobFilters: JobFilters = {
  tags: [],
  mountAndServiceTags: [],
  priorities: [],
  stages: [],
  dates: [],
  estCompleted: [],
  paymentReceivedDates: [],
  paymentStatus: [],
  searchTerm: "",
  species: "",
  service: "",
  mountType: "",
  sort: {
    key: "createdAt",
    direction: "desc",
  },
};

export const defaultClientFilters: ClientFilters = {
  searchTerm: "",
  tags: [],
  priorities: [],
  dates: [],
  totalSpend: [0, 50000],
  minJobCount: 0,
  hasOutstandingBalance: false,
  sort: {
    key: "createdAt",
    direction: "desc",
  },
};

export const defaultFilters: Filters = {
  job: defaultJobFilters,
  client: defaultClientFilters,
};
